var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "py-4" },
    [
      _vm.oncancel
        ? _c("modal-cancel", {
            attrs: { oncancel: _vm.oncancel, state: _vm.state, id: _vm.id },
            on: {
              onclose: function ($event) {
                _vm.oncancel = false
              },
              onreload: function ($event) {
                return _vm.$router.go()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("main", [
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "vstack gap-4" }, [
            _vm.loading == false && _vm.id
              ? _c("div", { staticClass: "card" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "card-header bg-white d-flex align-items-center justify-content-between",
                    },
                    [
                      _c("h5", { staticClass: "me-auto" }, [
                        _vm._v(
                          _vm._s(
                            _vm.state == 23
                              ? "Factura Reembolsada"
                              : _vm.state == 28
                              ? "Factura Anulada"
                              : "Factura"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.state == 24 &&
                      _vm.globalViewOption("ReimburseInvoice")
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-danger btn-h mr-3",
                              on: {
                                click: function ($event) {
                                  return _vm.NOTE_CREDIT()
                                },
                              },
                            },
                            [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "d-flex justify-content-center align-items-center",
                                },
                                [
                                  _vm._v(
                                    "\n                                Reembolsar factura\n                            "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.state != 28 &&
                      _vm.state != 24 &&
                      _vm.globalViewOption("CancelInvoice")
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-danger btn-h mr-3",
                              on: {
                                click: function ($event) {
                                  return _vm.NOTE_CREDIT()
                                },
                              },
                            },
                            [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "d-flex justify-content-center align-items-center",
                                },
                                [
                                  _vm._v(
                                    "\n                                Anular factura\n                            "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-neutral btn-m",
                          on: {
                            click: function ($event) {
                              return _vm.PRINT()
                            },
                          },
                        },
                        [_vm._m(1)]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-body p-0" },
                    [_c("billing", { attrs: { print: false } })],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "pb-4" }, [
          _c("div", { staticClass: "row align-items-end" }, [
            _c("div", { staticClass: "col-sm col-12" }, [
              _c("h1", { staticClass: "h2 ls-tight" }, [_vm._v("Factura")]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "small",
      { staticClass: "d-flex justify-content-center align-items-center" },
      [_c("i", { staticClass: "bi bi-printer" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }